import React from 'react';
import { Sparkles, Clock } from 'lucide-react';

const Hero = () => {
  const scrollToQuote = () => {
    const element = document.querySelector('#quote');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative pt-32 pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden min-h-[90vh] flex items-center">
      {/* Background Video */}
      <video
        autoPlay
        muted
        loop
        playsInline
        className="absolute inset-0 w-full h-full object-cover -z-20"
        poster="https://customer-assets-v7afamib.emergentagent.net/job_034ba03a-ab9b-460a-8d65-ab113159d799/artifacts/lf1m7ks6_window%20squigi.webp"
      >
        <source src="/hero-video.mp4" type="video/mp4" />
      </video>
      {/* Dark overlay for better text readability */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70 -z-10" />

      <div className="max-w-7xl mx-auto w-full">
        <div className="text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full shadow-lg border border-white/20 mb-6">
            <Sparkles className="w-4 h-4 text-blue-600" />
            <span className="text-sm font-medium text-gray-700">Welcome to</span>
          </div>

          {/* Company Name */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-6 drop-shadow-lg">
            <span className="text-gradient-reflections">Reflections</span> Cleanings
          </h1>

          {/* Main Headline */}
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-blue-300 mb-4 drop-shadow-md">
            The #1 Exterior Cleaning Company on Long Island
          </h2>

          {/* Subheadline */}
          <p className="max-w-4xl mx-auto text-lg sm:text-xl text-gray-100 leading-relaxed mb-10 drop-shadow-sm">
            Locally owned and trusted for over 15 years, we maintain the region's finest homes 
            with meticulous care — from glass and siding to roofs, gutters, and cedar restoration.
          </p>

          {/* CTA Button */}
          <div className="flex flex-col items-center gap-4">
            <button
              onClick={scrollToQuote}
              data-testid="hero-cta-button"
              className="group relative bg-blue-600 hover:bg-blue-700 text-white px-10 py-5 rounded-xl font-bold text-lg transition-all duration-300 transform hover:scale-105 shadow-xl hover:shadow-2xl"
            >
              <span className="relative z-10">Request a Quote</span>
              <div className="absolute inset-0 bg-blue-700 rounded-xl transform scale-0 group-hover:scale-100 transition-transform duration-300" />
            </button>
            
            <div className="flex items-center gap-2 text-gray-200">
              <Clock className="w-5 h-5 text-blue-400" />
              <span className="text-sm font-medium">Get a response within 1 business day</span>
            </div>
          </div>

          {/* Trust Indicators */}
          <div className="mt-12 flex flex-wrap justify-center gap-4 max-w-3xl mx-auto">
            <div className="bg-white/90 backdrop-blur-sm px-5 py-3 rounded-full shadow-md flex items-center gap-2">
              <span className="text-lg font-bold text-blue-600">100%</span>
              <span className="text-gray-700 text-sm font-medium">Satisfaction</span>
            </div>
            <div className="bg-white/90 backdrop-blur-sm px-5 py-3 rounded-full shadow-md flex items-center gap-2">
              <span className="text-lg font-bold text-blue-600">Fully</span>
              <span className="text-gray-700 text-sm font-medium">Insured & Licensed</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
